# Load Libraries
require('highcharts/highcharts.src')
require('highcharts/highcharts-more.src')
require('angular')
require('angular-route')
require('../../core/translation/translation-module')
require('../components/flash/flash-module')
require('../components/auth/auth-module')
require('../components/common-wrapper/common-wrapper-module')
require('../components/remote-api/remote-api-module')
require('../components/analysis-charts/analysis-charts-module')
require('../components/error-handler/error-handler-module')
require('../components/number/number-module')
require('../components/cache/cache-module')
require('../components/analyze-access/analyze-access-module')

# Load Templates
require('./dashboard.jade')
require('./history/history.jade')
require('./basic-analysis/basic-analysis.jade')
require('./best-score/best-score.jade')
require('./favorite-course/favorite-course.jade')
require('./fairway-hit/fairway-hit.jade')
require('./period-filter/period-filter.jade')

# Load Css
require('../../../sass/web/main/_main.scss')

# Load Dependencies
DashboardCtrl = require('./dashboard-controller')
DashboardHistoryCtrl = require('./history/history-controller')
DashboardBestScoreCtrl = require('./best-score/best-score-controller')
DashboardFavoriteCourseCtrl = require('./favorite-course/favorite-course-controller')
DashboardFairwayHitCtrl = require('./fairway-hit/fairway-hit-controller')
DashboardBasicAnalysisCtrl = require('./basic-analysis/basic-analysis-controller')
DashboardPeriodFilterCtrl = require('./period-filter/period-filter-controller')
DashboardService = require('./dashboard-service')
DashboardBasicAnalysisService = require('./basic-analysis/basic-analysis-service')
FairwayHitChartDirective = require("./fairway-hit/fairway-hit-chart-directive")

modules = [
  'ngRoute'
  'gnp-translation'
  'gnp-flash'
  'gnp-error-handler'
  'gnp-auth'
  'gnp-common-wrapper'
  'gnp-remote-api'
  'gnp-analysis-charts'
  'gnp-number'
  'gnp-cache'
  'gnp-analyze-access'
]
angular.module 'gnp-app-dashboard', modules
  .config ['$routeProvider', ($routeProvider) ->
    $routeProvider
      .when '/',
        templateUrl: 'web/dashboard/dashboard.jade'
        controller: 'DashboardCtrl'
        title: '_DASHBOARD.TITLE'
        resolve:
          userInfo: ['AuthService', 'AccountService', (AuthService, AccountService) ->
            AccountService.getUserInfo() if AuthService.isSignedIn()
          ]
        permission:
          signInRequired: true
  ]
  .config ['$translateProvider', ($translateProvider) ->
    $translateProvider
    .translations 'en', require('./i18n/en')
    .translations 'ja', require('./i18n/ja')
  ]
  .controller 'DashboardCtrl', DashboardCtrl
  .controller 'DashboardHistoryCtrl', DashboardHistoryCtrl
  .controller 'DashboardBestScoreCtrl', DashboardBestScoreCtrl
  .controller 'DashboardFavoriteCourseCtrl', DashboardFavoriteCourseCtrl
  .controller 'DashboardFairwayHitCtrl', DashboardFairwayHitCtrl
  .controller 'DashboardBasicAnalysisCtrl', DashboardBasicAnalysisCtrl
  .controller 'DashboardPeriodFilterCtrl', DashboardPeriodFilterCtrl
  .factory 'DashboardService', DashboardService
  .factory 'DashboardBasicAnalysisService', DashboardBasicAnalysisService
  .directive "gnpFairwayHitChart", FairwayHitChartDirective



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/dashboard/dashboard-module.coffee